import { Injectable } from "@angular/core";
@Injectable()
export class ApplicationMinutesDto {
    id: number;
    applicationId: number;
    hearingId: number;
    minutesNote: string;
    hearingDate: Date;
    applicationIds: number[];   // used when filing a Batch of Minutes (from Agenda module)
}
